import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  styled,
  Typography
} from '@mui/material';
import { fDate, fDateTime } from '../../../utils/formatTime';
import Label from '../../Label';
import { useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import DialogActionReports from './AcceptReportForm';
import { fCurrency } from '../../../utils/formatNumber';
import { Icon } from '@iconify/react';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import CancelIcon from '@mui/icons-material/Cancel';

const CuztomBox = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: '90px 1fr',
  gap: '10px'
}));

export default function DialogEditarRol({ open, onClose, data }) {
  const [updateRol, setUpdateRol] = useState(false);
  const [action, setAction] = useState('aceptar');

  const { displayName, userType } = data;

  //   console.log('la data', data);

  const handleClose = () => {
    onClose(false);
  };

  useEffect(() => {
    setUpdateRol(false);
  }, [setUpdateRol]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      //   maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Detalle del usuario</DialogTitle>
      <DialogContent>
        <CuztomBox>
          <Typography variant="subtitle1">Usuario:</Typography>
          <Typography>{displayName}</Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle1">Rol:</Typography>
          <Typography>{userType}</Typography>
        </CuztomBox>
        {!updateRol && (
          <Box marginTop="15px">
            <Button variant="contained" onClick={() => setUpdateRol(true)}>
              Modificar rol
            </Button>
          </Box>
        )}
        {updateRol && (
          <Box marginTop="15px" display="flex" flexDirection="column">
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Roles</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel value="female" control={<Radio />} label="Admin" />
                <FormControlLabel value="male" control={<Radio />} label="Cliente-licenciatario" />
                <FormControlLabel value="other" control={<Radio />} label="Usuario" />
              </RadioGroup>
            </FormControl>
            <Box marginTop="15px" display="flex" gap="10px">
              <Button variant="contained" color="error">
                Guardar nuevo rol
              </Button>
              <Button onClick={() => setUpdateRol(false)} variant="contained" color="info">
                Cerrar
              </Button>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Volver
        </Button>
      </DialogActions>
    </Dialog>
  );
}
